import { Icon, Icons } from "@ir/ui";
import {
  SearchInput,
  type SearchInputProps,
} from "@src/presentation/components/common";
import { ConfigSearchBy } from "./ConfigSearchBy";

interface ConfigSearchInputProps
  extends Omit<SearchInputProps, "prefix" | "suffix"> {
  fields: readonly string[];
  searchByTitle?: string;
}

/**
 * Config list search: Search by Popover on the left, search icon on the right.
 */
export function ConfigSearchInput({
  fields,
  searchByTitle,
  ...searchProps
}: Readonly<ConfigSearchInputProps>) {
  return (
    <SearchInput
      {...searchProps}
      prefix={<ConfigSearchBy fields={fields} title={searchByTitle} />}
      suffix={
        <Icon
          name={Icons.Search}
          size="small"
          color="grey"
          style={{ color: "var(--grey-400)" }}
        />
      }
    />
  );
}
